import { Api } from './Api';
import { ApiActor } from './ApiActor';
import { ApiRequestOptions } from './ApiRequestOptions';
import { GetEndpointMethodNames } from './GetEndpointMethodNames';
import React from 'react';

export const useFetched = <
  TApi extends Api<any>,
  TPath extends TApi['Path'],
  TMethod extends GetEndpointMethodNames<TApi, TPath>,
>(
  apiActor: ApiActor<TApi, TPath, TMethod>,
  options?: ApiRequestOptions<TApi, TPath, TMethod>,
  config: { authenticated?: boolean; skipError?: boolean } = {},
): ApiActor<TApi, TPath, TMethod> => {
  const { data, fetching, fetch, error } = apiActor;

  React.useEffect(() => {
    if (
      !fetching &&
      data === undefined &&
      error === undefined &&
      (config.authenticated ? sessionStorage.getItem('token') !== null : true)
    ) {
      if (config.skipError) {
        fetch(options).catch(() => {});
      } else {
        fetch(options);
      }
    }
  }, []);

  return apiActor;
};
